import type { ReactNode } from "react";
import { Chip, Grid } from "@mui/material";
import type { GridProps } from "@mui/material";
import { useSearch } from "providers";
import { CommuneIcon, CollectiviteIcon, PerimetreIcon } from "icons";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PersonIcon from "@mui/icons-material/Person";
import type { CollectiviteSearchItem } from "models";
import type { SvgIconComponent } from "@mui/icons-material";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const availableCategories: Array<{
  label: string;
  categories: CollectiviteSearchItem["type"] | Array<CollectiviteSearchItem["type"]>;
  Icon: SvgIconComponent;
}> = [
  { label: "Communes", categories: ["COMMUNE", "COMMUNEASSDEG"], Icon: CommuneIcon },
  { label: "EPCI", categories: "EPCI", Icon: CollectiviteIcon },
  { label: "Périmètres SDEA", categories: "PERIMETRE", Icon: PerimetreIcon },
  { label: "Territoires", categories: "TERRITOIRE", Icon: AccountBalanceIcon },
  { label: "Élus", categories: "ELU", Icon: PersonIcon },
];

interface SearchCategoriesProps extends GridProps {
  inputSize?: "small" | "medium";
  onFocus?: VoidFunction;
}

export function SearchCategories({
  sx,
  inputSize = "medium",
  onFocus,
  ...props
}: Readonly<SearchCategoriesProps>): ReactNode {
  const { searchCategories, toggleSearchCategories, setSearchCategories } = useSearch();

  return (
    <Grid container size={12} spacing={1} sx={{ justifyContent: "center", ...sx }} {...props}>
      <Chip
        label="Tout"
        icon={<DoneAllIcon fontSize="small" />}
        color={
          searchCategories.length ===
            availableCategories.flatMap(({ categories }) => categories).length ||
          searchCategories.length === 0
            ? "primary"
            : undefined
        }
        onClick={(e) => {
          setSearchCategories([]);
          e.stopPropagation();
        }}
        sx={{ pl: "6px" }}
      />
      {availableCategories.map(({ label, categories, Icon }) => {
        const active = searchCategories.includes(
          Array.isArray(categories) ? categories[0] : categories
        );
        return (
          <Chip
            key={label}
            icon={<Icon fontSize="small" />}
            label={label}
            color={active ? "primary" : undefined}
            onClick={(e) => {
              toggleSearchCategories(categories);
              e.stopPropagation();
            }}
            sx={{ pl: "6px" }}
          />
        );
      })}
    </Grid>
  );
}
